import React from 'react';

const BulbIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 9.33398C10.1333 8.66732 10.4667 8.20065 11 7.66732C11.6667 7.06732 12 6.20065 12 5.33398C12 4.27312 11.5786 3.2557 10.8284 2.50556C10.0783 1.75541 9.06087 1.33398 8 1.33398C6.93913 1.33398 5.92172 1.75541 5.17157 2.50556C4.42143 3.2557 4 4.27312 4 5.33398C4 6.00065 4.13333 6.80065 5 7.66732C5.46667 8.13398 5.86667 8.66732 6 9.33398M6 12.0007H10M6.66667 14.6673H9.33333'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default BulbIcon;
